import { axiosInstance } from "./axios";

export interface ChatRequest {
    prompt: string;
    conversationId: string;
}

export interface ChatResponse {
    prompt: string;
    output: string;
    conversationId: string;
}

export interface ConversationDto {
    id: number;
    conversationId: string;
    createdAt: string;
    updatedAt: string;
    title: string;
    messageCount: number;
}

export interface ConversationDetailsDto extends ConversationDto {
    messages: ConversationMessageDto[];
    contextSummary: Record<string, number>;
}

export interface ConversationMessageDto {
    id: number;
    role: string;
    content: string;
    createdAt: string;
}

export interface CreateConversationRequest {
    conversationId?: string;
    title?: string;
}

export const chatApi = {
    // Conversation management
    getConversations: async (): Promise<ConversationDto[]> => {
        const response = await axiosInstance.get<ConversationDto[]>("/conversations");
        return response.data;
    },

    createConversation: async (request: CreateConversationRequest = {}): Promise<ConversationDto> => {
        const response = await axiosInstance.post<ConversationDto>("/conversations", request);
        return response.data;
    },

    getConversation: async (conversationId: string): Promise<ConversationDetailsDto> => {
        const response = await axiosInstance.get<ConversationDetailsDto>(`/conversations/${conversationId}`);
        return response.data;
    },

    deleteConversation: async (conversationId: string): Promise<void> => {
        await axiosInstance.delete(`/conversations/${conversationId}`);
    },

    // Chat messaging
    sendMessage: async (prompt: string, conversationId: string): Promise<ChatResponse> => {
        const response = await axiosInstance.post<ChatResponse>("/chat", {
            prompt,
            conversationId,
        });
        return response.data;
    },
};
